import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";
import i18n from "@/i18n";

import {
  HelpButton,
  HelpIntro,
  HelpScreen,
  HelpSection,
  InfoNote,
} from "@/components/help/help-ui";
import { getPlusPlanFeatures } from "@/constants/plans";

export default function BillingPlus() {
  useTranslation();
  const router = useRouter();

  function openPlan() {
    router.push("/pricing" as never);
  }

  return (
    <HelpScreen title={i18n.t("help.billing.title")}>
      <HelpIntro>{i18n.t("help.billing.intro")}</HelpIntro>

      <HelpSection
        heading={i18n.t("help.billing.includes")}
        bullets={getPlusPlanFeatures()}
      />

      <InfoNote icon="refresh-outline">
        {i18n.t("help.billing.rollover")}
      </InfoNote>

      <HelpButton
        label={i18n.t("help.billing.manage")}
        icon="card-outline"
        onPress={openPlan}
      />

      <HelpButton
        label={i18n.t("help.billing.contact")}
        icon="chatbubbles-outline"
        onPress={() =>
          router.push(
            `/help/contact?source=contact&category=${encodeURIComponent("Billing/Plus")}`,
          )
        }
      />
    </HelpScreen>
  );
}
